"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var regionActions = require("@caddigital/sok-reducers/lib/actions/customer/region");
var salesmanActions = require("@caddigital/sok-reducers/lib/actions/customer/salesman");
var membersActions = require("@caddigital/sok-reducers/lib/actions/customer/members");
var userGroupsActions = require("@caddigital/sok-reducers/lib/actions/customer/userGroups");
var ytjActions = require("@caddigital/sok-reducers/lib/actions/customer/ytj");
var wizardActions = require("@caddigital/sok-reducers/lib/actions/customer/wizard");
var allFeatureActions = require("@caddigital/sok-reducers/lib/actions/features/all");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var Types = require("types");
var Step1_1 = require("./steps/Step1");
var Step2_1 = require("./steps/Step2");
var Step3_1 = require("./steps/Step3");
var Step4_1 = require("./steps/Step4");
var Buttons_1 = require("./Buttons");
var translate_1 = require("utils/translate");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        wizardStep: state.customer.wizard.wizardStep,
        step1: state.customer.wizard.step1,
        customerId: state.customer.wizard.customerId,
        customerUuid: state.customer.wizard.customerUuid,
        customerName: state.customer.wizard.customerName,
        businessId: state.customer.wizard.businessId,
        selectedLanguage: selectedLanguage,
        fetchingCustomer: state.customer.wizard.fetchingCustomer,
        features: state.features.all
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    init: function () { return (dispatch(regionActions.fetchRequest()),
        dispatch(salesmanActions.fetchRequest()),
        dispatch(allFeatureActions.fetchAllRequest())); },
    fetchCustomer: function (customerId) { return (dispatch(wizardActions.fetchCustomerRequest(customerId)),
        dispatch(wizardActions.fetchContractFilesRequest(customerId)),
        dispatch(wizardActions.fetchFeaturesRequest(customerId))); },
    changeStep: function (step) { return dispatch(wizardActions.changeStep(step)); },
    saveCustomer: function (props) { return function () {
        return dispatch(wizardActions.saveCustomerRequest(props.customerUuid, {
            type: 'ADMIN',
            name: props.step1.companyName,
            hasBusinessId: props.step1.hasBusinessId,
            businessId: props.step1.businessId,
            street: props.step1.street,
            postalCode: props.step1.postalCode,
            city: props.step1.city,
            state: props.step1.state,
            country: props.step1.country,
            client: props.step1.client,
            salesRepresentative: props.step1.salesman,
            features: props.step1.features
        }, props.step1.companyLogo.file, props.step1.files));
    }; },
    clear: function () { return (dispatch(wizardActions.clearState()),
        dispatch(regionActions.clearState()),
        dispatch(salesmanActions.clearState()),
        dispatch(membersActions.clearState()),
        dispatch(userGroupsActions.clearState()),
        dispatch(ytjActions.searchYtjClear())); },
    setCustomerFeatures: function (features) {
        return dispatch(wizardActions.copyAll(features));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CustomerWizard'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.init();
        if (this.props.match.params.customerId !== undefined) {
            this.props.fetchCustomer(parseInt(this.props.match.params.customerId, 10));
        }
        if (this.props.match.params.customerId === undefined &&
            this.props.features.status === 'FETCHED') {
            this.props.setCustomerFeatures(this.props.features.all);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.features.status === 'FETCHED' &&
            this.props.features.status !== prevProps.features.status &&
            this.props.step1.featuresStatus === 'STANDBY') {
            this.props.setCustomerFeatures(this.props.features.all);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var getStep = function (props) { return ({
    0: React.createElement(Step1_1.default, null),
    1: React.createElement(Step2_1.default, { customerId: props.customerId }),
    2: React.createElement(Step3_1.default, { customerId: props.customerId, customerUuid: props.customerUuid }),
    3: React.createElement(Step4_1.default, { customerUuid: props.customerUuid })
}); };
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'create-new-customer-view' },
    React.createElement("main", { className: 'content' },
        React.createElement(sok_ui_1.BreadCrumb, null,
            React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
            React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/admin/customermanagement") }, (0, translation_1.getLocalization)('breadcrumb/admin/customerManagement')),
            props.match.params.customerId === undefined ? (React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/admin/customerManangement/createNewCustomer'))) : (React.createElement("span", null,
                props.customerName,
                props.businessId !== null &&
                    props.businessId !== '' &&
                    " (".concat(props.businessId, ")")))),
        React.createElement(sok_ui_1.StepBar, { currentStep: props.wizardStep, onChange: props.changeStep, steps: [
                (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/wizardStep/basicInformation'),
                (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/wizardStep/AdditionalInformationForTheProjects'),
                (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/wizardStep/users'),
                (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/wizardStep/templates')
            ] }),
        React.createElement(Buttons_1.default, __assign({}, props)),
        props.fetchingCustomer === 'FETCHED' ||
            props.fetchingCustomer === 'STANDBY' ? (getStep(props)[props.wizardStep]) : props.fetchingCustomer === 'FETCHING' ? (React.createElement("div", { className: 'loading-customer' },
            React.createElement(sok_ui_1.LoadingSpinner, null),
            React.createElement("div", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/loading')))) : ((props.fetchingCustomer === 'FAILURE' ||
            props.match.params.customerId === undefined) && (React.createElement(GenericErrorMessage_1.default, null,
            React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                    if (props.match.params.customerId !== undefined) {
                        props.fetchCustomer(parseInt(props.match.params.customerId, 10));
                    }
                } }))))))); });
